$ = jQuery;
import { hideQuickSearch } from "./quickSearch";

const CSS_MENU_OPENING = "HeaderMenu--opening";
const CSS_MENU_OPENED = "HeaderMenu--opened";
const SELECTOR_MENU = ".js-headermenu-parent";

let mouseLeaveTimeout = 0;
let removeClassTimeout = 0;

export function closeMenus(animate = false) {
  const $menu = $(SELECTOR_MENU);

  if (animate) {
    $menu.removeClass(CSS_MENU_OPENED);
    removeClassTimeout = window.setTimeout(() => {
      $menu.removeClass(CSS_MENU_OPENING);
    }, 500);
  } else {
    $menu.removeClass(`${CSS_MENU_OPENED} ${CSS_MENU_OPENING}`);
  }
}

function isMenuOpened() {
  return $(SELECTOR_MENU).hasClass(CSS_MENU_OPENING);
}

function startCloseMenuTimeout() {
  mouseLeaveTimeout = window.setTimeout(function() {
    closeMenus(true);
  }, 300);
}

function cancelCloseMenuTimeout() {
  window.clearTimeout(mouseLeaveTimeout);
  window.clearTimeout(removeClassTimeout);
}

function setupMenu() {
  const links = $(`${SELECTOR_MENU} > a`);
  const menus = $(SELECTOR_MENU);

  links.click(function(event) {
    event.preventDefault();
  });

  links.mouseover(function() {
    const $menu = $(this).closest(SELECTOR_MENU);
    hideQuickSearch();

    if (isMenuOpened()) {
      closeMenus(false);
      $menu.addClass(`${CSS_MENU_OPENED} ${CSS_MENU_OPENING}`);
    } else {
      window.requestAnimationFrame(() => {
        $menu.addClass(CSS_MENU_OPENING);
        window.requestAnimationFrame(() => {
          $menu.addClass(CSS_MENU_OPENED);
        });
      });
    }
  });

  menus.mouseleave(function() {
    startCloseMenuTimeout();
  });

  menus.mouseover(function() {
    cancelCloseMenuTimeout();
  });
}

export default function() {
  $(setupMenu);
}